import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonToolbar, IonButtons, IonButton, IonTitle, IonIcon } from "@ionic/vue";
import { chevronBack } from "ionicons/icons";


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterHeader',
  props: {
    title: {}
  },
  emits: ["back"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonToolbar), {
    class: "background-purple-background purple-light-color",
    style: {"--border-width":"0"}
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonButtons), { slot: "start" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonButton), {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back'))),
            class: "purple-light-color"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), { icon: _unref(chevronBack) }, null, 8, ["icon"]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('button.back')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonTitle), { mode: "ios" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.title ?? _ctx.$t('titleRoute.filter')), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(IonButtons), {
        slot: "end",
        style: {"width":"calc(44px + 3.4rem)"}
      })
    ]),
    _: 1
  }))
}
}

})